import React from 'react';
import {Input} from 'reactstrap';
import '../../../styles/layout/forms/Select.css'

const Select = ({ value, onChange,options,label,text,keyBase }) => {
    return (
        <div className="theme-select">
            <label>{label}</label>
            <Input   
                type="select"
                value={value}
                onChange={onChange}                
                text={text}
            >
                {options.map(option => (
                    <option value={option.value} key={`${keyBase}-${option.value}`}>                    
                        {option.text}
                    </option>
                ))}
            </Input>
        </div>
    )
}
export default Select